<template>
  <div class="aboutUsPage">
    <div class="bannerBox"></div>

    <div class="contentBox">

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  beforeCreate () {
    document.title = this.$route.meta.title
  }
}
</script>
<style lang="scss" scoped>
.bannerBox {
  width: 100%;
  height: 420px;
  min-width: 1200px;
  background: url(https://htmlqiniu.jihex.com/homepageBanner.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
.contentBox {
  min-width: 1200px;
  width: 100%;
  height: 1019px;
  min-width: 1200px;
  background: url(https://htmlqiniu.jihex.com/%E5%85%B3%E4%BA%8E%E5%A4%AA%E7%9B%AE.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
</style>


// WEBPACK FOOTER //
// src/view/aboutUs.vue